module.exports = __webpack_public_path__ + "img/slide12.42e0e7ac.png";